import createStringFacet from '../createStringFacet';

export default createStringFacet({ stateKey: 'names', itemKey: 'shortName' });
